// Backend-confirmed convention: the Matrix local-part is the email's local-part verbatim
// (case preserved, no normalization), e.g. aripan017@gmail.com -> @aripan017:<homeserverDomain>.
export const toMatrixUserId = (email: string, homeserverDomain: string): string => `@${email.split('@')[0]}:${homeserverDomain}`;
